import { approvalChartDefault } from "./defaults.ts";

export const obamaApp = [
  { start: new Date(`2017 Jan 16`), app: 59, dis: 37, neu: 4 },
  { start: new Date(`2017 Jan 9`), app: 57, dis: 39, neu: 4 },
  { start: new Date(`2017 Jan 2`), app: 55, dis: 42, neu: 3 },
  { start: new Date(`2016 Dec 26`), app: 55, dis: 40, neu: 4 },
  { start: new Date(`2016 Dec 19`), app: 56, dis: 40, neu: 3 },
  { start: new Date(`2016 Dec 12`), app: 56, dis: 40, neu: 4 },
  { start: new Date(`2016 Dec 5`), app: 57, dis: 40, neu: 3 },
  { start: new Date(`2016 Nov 28`), app: 54, dis: 43, neu: 3 },
  { start: new Date(`2016 Nov 21`), app: 56, dis: 40, neu: 4 },
  { start: new Date(`2016 Nov 14`), app: 56, dis: 41, neu: 3 },
  { start: new Date(`2016 Nov 7`), app: 57, dis: 41, neu: 3 },
  { start: new Date(`2016 Oct 31`), app: 53, dis: 45, neu: 2 },
  { start: new Date(`2016 Oct 24`), app: 54, dis: 44, neu: 3 },
  { start: new Date(`2016 Oct 17`), app: 55, dis: 42, neu: 3 },
  { start: new Date(`2016 Oct 10`), app: 54, dis: 43, neu: 4 },
  { start: new Date(`2016 Oct 3`), app: 52, dis: 45, neu: 3 },
  { start: new Date(`2016 Sep 26`), app: 53, dis: 44, neu: 4 },
  { start: new Date(`2016 Sep 19`), app: 53, dis: 43, neu: 4 },
  { start: new Date(`2016 Sep 12`), app: 52, dis: 44, neu: 4 },
  { start: new Date(`2016 Sep 5`), app: 51, dis: 45, neu: 4 },
  { start: new Date(`2016 Aug 29`), app: 52, dis: 44, neu: 5 },
  { start: new Date(`2016 Aug 22`), app: 51, dis: 45, neu: 5 },
  { start: new Date(`2016 Aug 15`), app: 51, dis: 44, neu: 4 },
  { start: new Date(`2016 Aug 8`), app: 52, dis: 44, neu: 4 },
  { start: new Date(`2016 Aug 1`), app: 52, dis: 45, neu: 4 },
  { start: new Date(`2016 Jul 25`), app: 53, dis: 44, neu: 4 },
  { start: new Date(`2016 Jul 18`), app: 49, dis: 47, neu: 4 },
  { start: new Date(`2016 Jul 11`), app: 49, dis: 46, neu: 5 },
  { start: new Date(`2016 Jul 4`), app: 51, dis: 45, neu: 4 },
  { start: new Date(`2016 Jun 27`), app: 51, dis: 45, neu: 5 },
  { start: new Date(`2016 Jun 20`), app: 50, dis: 46, neu: 5 },
  { start: new Date(`2016 Jun 13`), app: 53, dis: 44, neu: 4 },
  { start: new Date(`2016 Jun 6`), app: 53, dis: 43, neu: 4 },
  { start: new Date(`2016 May 30`), app: 51, dis: 44, neu: 5 },
  { start: new Date(`2016 May 23`), app: 52, dis: 44, neu: 4 },
  { start: new Date(`2016 May 16`), app: 51, dis: 45, neu: 5 },
  { start: new Date(`2016 May 9`), app: 51, dis: 45, neu: 4 },
  { start: new Date(`2016 May 2`), app: 52, dis: 44, neu: 4 },
  { start: new Date(`2016 Apr 25`), app: 51, dis: 46, neu: 4 },
  { start: new Date(`2016 Apr 18`), app: 51, dis: 45, neu: 4 },
  { start: new Date(`2016 Apr 11`), app: 48, dis: 47, neu: 4 },
  { start: new Date(`2016 Apr 4`), app: 51, dis: 45, neu: 4 },
  { start: new Date(`2016 Mar 28`), app: 51, dis: 45, neu: 4 },
  { start: new Date(`2016 Mar 21`), app: 53, dis: 44, neu: 3 },
  { start: new Date(`2016 Mar 14`), app: 50, dis: 46, neu: 4 },
  { start: new Date(`2016 Mar 7`), app: 51, dis: 45, neu: 4 },
  { start: new Date(`2016 Feb 29`), app: 50, dis: 46, neu: 4 },
  { start: new Date(`2016 Feb 22`), app: 48, dis: 47, neu: 5 },
  { start: new Date(`2016 Feb 15`), app: 48, dis: 48, neu: 4 },
  { start: new Date(`2016 Feb 8`), app: 48, dis: 48, neu: 4 },
  { start: new Date(`2016 Feb 1`), app: 47, dis: 50, neu: 3 },
  { start: new Date(`2016 Jan 25`), app: 48, dis: 48, neu: 4 },
  { start: new Date(`2016 Jan 18`), app: 48, dis: 47, neu: 5 },
  { start: new Date(`2016 Jan 11`), app: 48, dis: 47, neu: 5 },
  { start: new Date(`2016 Jan 4`), app: 47, dis: 49, neu: 4 },
  { start: new Date(`2015 Dec 28`), app: 45, dis: 52, neu: 4 },
  { start: new Date(`2015 Dec 21`), app: 48, dis: 49, neu: 3 },
  { start: new Date(`2015 Dec 14`), app: 45, dis: 51, neu: 5 },
  { start: new Date(`2015 Dec 7`), app: 45, dis: 50, neu: 5 },
  { start: new Date(`2015 Nov 30`), app: 47, dis: 49, neu: 4 },
  { start: new Date(`2015 Nov 23`), app: 46, dis: 49, neu: 5 },
  { start: new Date(`2015 Nov 16`), app: 44, dis: 52, neu: 4 },
  { start: new Date(`2015 Nov 9`), app: 49, dis: 47, neu: 4 },
  { start: new Date(`2015 Nov 2`), app: 49, dis: 48, neu: 3 },
  { start: new Date(`2015 Oct 26`), app: 47, dis: 49, neu: 4 },
  { start: new Date(`2015 Oct 19`), app: 46, dis: 50, neu: 4 },
  { start: new Date(`2015 Oct 12`), app: 46, dis: 50, neu: 4 },
  { start: new Date(`2015 Oct 5`), app: 46, dis: 50, neu: 5 },
  { start: new Date(`2015 Sep 28`), app: 47, dis: 49, neu: 5 },
  { start: new Date(`2015 Sep 21`), app: 48, dis: 49, neu: 3 },
  { start: new Date(`2015 Sep 14`), app: 46, dis: 51, neu: 4 },
  { start: new Date(`2015 Sep 7`), app: 46, dis: 49, neu: 5 },
  { start: new Date(`2015 Aug 31`), app: 46, dis: 50, neu: 4 },
  { start: new Date(`2015 Aug 24`), app: 46, dis: 50, neu: 4 },
  { start: new Date(`2015 Aug 17`), app: 44, dis: 51, neu: 5 },
  { start: new Date(`2015 Aug 10`), app: 46, dis: 49, neu: 5 },
  { start: new Date(`2015 Aug 3`), app: 46, dis: 50, neu: 4 },
  { start: new Date(`2015 Jul 27`), app: 46, dis: 49, neu: 5 },
  { start: new Date(`2015 Jul 20`), app: 46, dis: 50, neu: 5 },
  { start: new Date(`2015 Jul 13`), app: 46, dis: 48, neu: 6 },
  { start: new Date(`2015 Jul 6`), app: 46, dis: 49, neu: 5 },
  { start: new Date(`2015 Jun 29`), app: 46, dis: 49, neu: 5 },
  { start: new Date(`2015 Jun 22`), app: 47, dis: 49, neu: 5 },
  { start: new Date(`2015 Jun 15`), app: 45, dis: 50, neu: 6 },
  { start: new Date(`2015 Jun 8`), app: 45, dis: 49, neu: 5 },
  { start: new Date(`2015 Jun 1`), app: 46, dis: 49, neu: 5 },
  { start: new Date(`2015 May 25`), app: 47, dis: 49, neu: 5 },
  { start: new Date(`2015 May 18`), app: 46, dis: 49, neu: 5 },
  { start: new Date(`2015 May 11`), app: 47, dis: 49, neu: 5 },
  { start: new Date(`2015 May 4`), app: 47, dis: 48, neu: 5 },
  { start: new Date(`2015 Apr 27`), app: 48, dis: 48, neu: 4 },
  { start: new Date(`2015 Apr 20`), app: 45, dis: 49, neu: 6 },
  { start: new Date(`2015 Apr 13`), app: 46, dis: 50, neu: 4 },
  { start: new Date(`2015 Apr 6`), app: 48, dis: 48, neu: 4 },
  { start: new Date(`2015 Mar 30`), app: 47, dis: 48, neu: 5 },
  { start: new Date(`2015 Mar 23`), app: 46, dis: 49, neu: 5 },
  { start: new Date(`2015 Mar 16`), app: 45, dis: 50, neu: 5 },
  { start: new Date(`2015 Mar 9`), app: 47, dis: 48, neu: 5 },
  { start: new Date(`2015 Mar 2`), app: 46, dis: 49, neu: 5 },
  { start: new Date(`2015 Feb 23`), app: 45, dis: 50, neu: 5 },
  { start: new Date(`2015 Feb 16`), app: 46, dis: 49, neu: 5 },
  { start: new Date(`2015 Feb 9`), app: 47, dis: 48, neu: 5 },
  { start: new Date(`2015 Feb 2`), app: 46, dis: 49, neu: 5 },
  { start: new Date(`2015 Jan 26`), app: 47, dis: 48, neu: 5 },
  { start: new Date(`2015 Jan 19`), app: 49, dis: 47, neu: 5 },
  { start: new Date(`2015 Jan 12`), app: 46, dis: 49, neu: 5 },
  { start: new Date(`2015 Jan 5`), app: 46, dis: 48, neu: 7 },
  { start: new Date(`2014 Dec 29`), app: 46, dis: 48, neu: 5 },
  { start: new Date(`2014 Dec 22`), app: 44, dis: 50, neu: 6 },
  { start: new Date(`2014 Dec 15`), app: 45, dis: 51, neu: 5 },
  { start: new Date(`2014 Dec 8`), app: 43, dis: 52, neu: 5 },
  { start: new Date(`2014 Dec 1`), app: 43, dis: 52, neu: 5 },
  { start: new Date(`2014 Nov 24`), app: 43, dis: 52, neu: 5 },
  { start: new Date(`2014 Nov 17`), app: 42, dis: 53, neu: 5 },
  { start: new Date(`2014 Nov 10`), app: 42, dis: 52, neu: 6 },
  { start: new Date(`2014 Nov 3`), app: 40, dis: 54, neu: 5 },
  { start: new Date(`2014 Oct 27`), app: 42, dis: 53, neu: 5 },
  { start: new Date(`2014 Oct 20`), app: 42, dis: 53, neu: 5 },
  { start: new Date(`2014 Oct 13`), app: 41, dis: 54, neu: 6 },
  { start: new Date(`2014 Oct 6`), app: 41, dis: 55, neu: 5 },
  { start: new Date(`2014 Sep 29`), app: 43, dis: 53, neu: 5 },
  { start: new Date(`2014 Sep 22`), app: 42, dis: 52, neu: 6 },
  { start: new Date(`2014 Sep 15`), app: 43, dis: 52, neu: 5 },
  { start: new Date(`2014 Sep 8`), app: 41, dis: 54, neu: 5 },
  { start: new Date(`2014 Sep 1`), app: 40, dis: 53, neu: 7 },
  { start: new Date(`2014 Aug 25`), app: 41, dis: 53, neu: 7 },
  { start: new Date(`2014 Aug 18`), app: 43, dis: 51, neu: 7 },
  { start: new Date(`2014 Aug 11`), app: 41, dis: 53, neu: 6 },
  { start: new Date(`2014 Aug 4`), app: 42, dis: 52, neu: 6 },
  { start: new Date(`2014 Jul 28`), app: 42, dis: 54, neu: 5 },
  { start: new Date(`2014 Jul 21`), app: 41, dis: 53, neu: 7 },
  { start: new Date(`2014 Jul 14`), app: 43, dis: 51, neu: 6 },
  { start: new Date(`2014 Jul 7`), app: 42, dis: 53, neu: 5 },
  { start: new Date(`2014 Jun 30`), app: 43, dis: 52, neu: 5 },
  { start: new Date(`2014 Jun 23`), app: 42, dis: 52, neu: 6 },
  { start: new Date(`2014 Jun 16`), app: 41, dis: 55, neu: 5 },
  { start: new Date(`2014 Jun 9`), app: 42, dis: 52, neu: 6 },
  { start: new Date(`2014 Jun 2`), app: 44, dis: 50, neu: 6 },
  { start: new Date(`2014 May 26`), app: 44, dis: 51, neu: 5 },
  { start: new Date(`2014 May 19`), app: 43, dis: 52, neu: 5 },
  { start: new Date(`2014 May 12`), app: 44, dis: 51, neu: 5 },
  { start: new Date(`2014 May 5`), app: 45, dis: 50, neu: 5 },
  { start: new Date(`2014 Apr 28`), app: 44, dis: 50, neu: 6 },
  { start: new Date(`2014 Apr 21`), app: 44, dis: 50, neu: 5 },
  { start: new Date(`2014 Apr 14`), app: 44, dis: 50, neu: 6 },
  { start: new Date(`2014 Apr 7`), app: 43, dis: 51, neu: 6 },
  { start: new Date(`2014 Mar 31`), app: 44, dis: 51, neu: 5 },
  { start: new Date(`2014 Mar 24`), app: 43, dis: 52, neu: 5 },
  { start: new Date(`2014 Mar 17`), app: 44, dis: 51, neu: 5 },
  { start: new Date(`2014 Mar 10`), app: 40, dis: 54, neu: 5 },
  { start: new Date(`2014 Mar 3`), app: 43, dis: 53, neu: 4 },
  { start: new Date(`2014 Feb 24`), app: 42, dis: 54, neu: 4 },
  { start: new Date(`2014 Feb 17`), app: 45, dis: 51, neu: 5 },
  { start: new Date(`2014 Feb 10`), app: 40, dis: 53, neu: 8 },
  { start: new Date(`2014 Feb 3`), app: 41, dis: 51, neu: 8 },
  { start: new Date(`2014 Jan 27`), app: 42, dis: 50, neu: 8 },
  { start: new Date(`2014 Jan 20`), app: 42, dis: 50, neu: 9 },
  { start: new Date(`2014 Jan 13`), app: 40, dis: 52, neu: 9 },
  { start: new Date(`2014 Jan 6`), app: 41, dis: 51, neu: 8 },
  { start: new Date(`2014 Jan 1`), app: 41, dis: 53, neu: 6 },
  { start: new Date(`2013 Dec 23`), app: 43, dis: 51, neu: 7 },
  { start: new Date(`2013 Dec 16`), app: 40, dis: 52, neu: 8 },
  { start: new Date(`2013 Dec 9`), app: 42, dis: 50, neu: 9 },
  { start: new Date(`2013 Dec 2`), app: 41, dis: 51, neu: 9 },
  { start: new Date(`2013 Nov 25`), app: 42, dis: 52, neu: 7 },
  { start: new Date(`2013 Nov 18`), app: 40, dis: 53, neu: 7 },
  { start: new Date(`2013 Nov 11`), app: 41, dis: 52, neu: 7 },
  { start: new Date(`2013 Nov 4`), app: 41, dis: 52, neu: 7 },
  { start: new Date(`2013 Oct 28`), app: 41, dis: 52, neu: 8 },
  { start: new Date(`2013 Oct 21`), app: 43, dis: 50, neu: 7 },
  { start: new Date(`2013 Oct 14`), app: 43, dis: 51, neu: 7 },
  { start: new Date(`2013 Oct 7`), app: 42, dis: 52, neu: 6 },
  { start: new Date(`2013 Sep 30`), app: 44, dis: 50, neu: 7 },
  { start: new Date(`2013 Sep 23`), app: 45, dis: 48, neu: 7 },
  { start: new Date(`2013 Sep 16`), app: 44, dis: 47, neu: 8 },
  { start: new Date(`2013 Sep 9`), app: 45, dis: 46, neu: 9 },
  { start: new Date(`2013 Sep 2`), app: 44, dis: 48, neu: 8 },
  { start: new Date(`2013 Aug 26`), app: 44, dis: 48, neu: 8 },
  { start: new Date(`2013 Aug 19`), app: 46, dis: 46, neu: 8 },
  { start: new Date(`2013 Aug 12`), app: 46, dis: 45, neu: 8 },
  { start: new Date(`2013 Aug 5`), app: 44, dis: 48, neu: 8 },
  { start: new Date(`2013 Jul 29`), app: 45, dis: 48, neu: 8 },
  { start: new Date(`2013 Jul 22`), app: 46, dis: 47, neu: 8 },
  { start: new Date(`2013 Jul 15`), app: 47, dis: 46, neu: 7 },
  { start: new Date(`2013 Jul 8`), app: 46, dis: 47, neu: 8 },
  { start: new Date(`2013 Jul 1`), app: 46, dis: 46, neu: 8 },
  { start: new Date(`2013 Jun 24`), app: 47, dis: 45, neu: 8 },
  { start: new Date(`2013 Jun 17`), app: 46, dis: 46, neu: 8 },
  { start: new Date(`2013 Jun 10`), app: 47, dis: 46, neu: 8 },
  { start: new Date(`2013 Jun 3`), app: 48, dis: 45, neu: 8 },
  { start: new Date(`2013 May 27`), app: 48, dis: 44, neu: 8 },
  { start: new Date(`2013 May 20`), app: 49, dis: 44, neu: 8 },
  { start: new Date(`2013 May 13`), app: 49, dis: 44, neu: 6 },
  { start: new Date(`2013 May 6`), app: 49, dis: 44, neu: 7 },
  { start: new Date(`2013 Apr 29`), app: 50, dis: 44, neu: 6 },
  { start: new Date(`2013 Apr 22`), app: 51, dis: 42, neu: 7 },
  { start: new Date(`2013 Apr 15`), app: 50, dis: 43, neu: 7 },
  { start: new Date(`2013 Apr 8`), app: 49, dis: 45, neu: 6 },
  { start: new Date(`2013 Apr 1`), app: 48, dis: 45, neu: 7 },
  { start: new Date(`2013 Mar 25`), app: 48, dis: 45, neu: 7 },
  { start: new Date(`2013 Mar 18`), app: 47, dis: 45, neu: 8 },
  { start: new Date(`2013 Mar 11`), app: 48, dis: 46, neu: 6 },
  { start: new Date(`2013 Mar 4`), app: 49, dis: 44, neu: 7 },
  { start: new Date(`2013 Feb 25`), app: 49, dis: 44, neu: 7 },
  { start: new Date(`2013 Feb 18`), app: 51, dis: 42, neu: 7 },
  { start: new Date(`2013 Feb 11`), app: 51, dis: 43, neu: 6 },
  { start: new Date(`2013 Feb 4`), app: 52, dis: 42, neu: 6 },
  { start: new Date(`2013 Jan 28`), app: 53, dis: 42, neu: 6 },
  { start: new Date(`2013 Jan 21`), app: 52, dis: 43, neu: 5 },
  { start: new Date(`2013 Jan 14`), app: 50, dis: 43, neu: 7 },
  { start: new Date(`2013 Jan 7`), app: 54, dis: 41, neu: 6 },
  { start: new Date(`2013 Jan 1`), app: 53, dis: 40, neu: 7 },
  { start: new Date(`2012 Dec 24`), app: 53, dis: 41, neu: 6 },
  { start: new Date(`2012 Dec 17`), app: 57, dis: 37, neu: 7 },
  { start: new Date(`2012 Dec 10`), app: 52, dis: 40, neu: 8 },
  { start: new Date(`2012 Dec 3`), app: 50, dis: 44, neu: 6 },
  { start: new Date(`2012 Nov 26`), app: 51, dis: 42, neu: 6 },
  { start: new Date(`2012 Nov 19`), app: 52, dis: 40, neu: 8 },
  { start: new Date(`2012 Nov 12`), app: 53, dis: 41, neu: 6 },
  { start: new Date(`2012 Nov 5`), app: 51, dis: 43, neu: 6 },
  { start: new Date(`2012 Oct 29`), app: 52, dis: 45, neu: 3 },
  { start: new Date(`2012 Oct 22`), app: 50, dis: 45, neu: 5 },
  { start: new Date(`2012 Oct 15`), app: 50, dis: 45, neu: 5 },
  { start: new Date(`2012 Oct 8`), app: 50, dis: 45, neu: 6 },
  { start: new Date(`2012 Oct 1`), app: 52, dis: 43, neu: 5 },
  { start: new Date(`2012 Sep 24`), app: 48, dis: 45, neu: 6 },
  { start: new Date(`2012 Sep 17`), app: 49, dis: 45, neu: 6 },
  { start: new Date(`2012 Sep 10`), app: 50, dis: 44, neu: 7 },
  { start: new Date(`2012 Sep 3`), app: 50, dis: 44, neu: 6 },
  { start: new Date(`2012 Aug 27`), app: 44, dis: 47, neu: 8 },
  { start: new Date(`2012 Aug 20`), app: 46, dis: 47, neu: 7 },
  { start: new Date(`2012 Aug 13`), app: 45, dis: 49, neu: 6 },
  { start: new Date(`2012 Aug 6`), app: 45, dis: 49, neu: 7 },
  { start: new Date(`2012 Jul 30`), app: 45, dis: 48, neu: 7 },
  { start: new Date(`2012 Jul 23`), app: 47, dis: 47, neu: 7 },
  { start: new Date(`2012 Jul 16`), app: 45, dis: 48, neu: 7 },
  { start: new Date(`2012 Jul 9`), app: 46, dis: 47, neu: 8 },
  { start: new Date(`2012 Jul 2`), app: 45, dis: 46, neu: 9 },
  { start: new Date(`2012 Jun 25`), app: 47, dis: 46, neu: 7 },
  { start: new Date(`2012 Jun 18`), app: 46, dis: 48, neu: 6 },
  { start: new Date(`2012 Jun 11`), app: 46, dis: 48, neu: 7 },
  { start: new Date(`2012 Jun 4`), app: 47, dis: 46, neu: 7 },
  { start: new Date(`2012 May 28`), app: 46, dis: 46, neu: 8 },
  { start: new Date(`2012 May 21`), app: 48, dis: 46, neu: 6 },
  { start: new Date(`2012 May 14`), app: 47, dis: 46, neu: 7 },
  { start: new Date(`2012 May 7`), app: 47, dis: 47, neu: 7 },
  { start: new Date(`2012 Apr 30`), app: 48, dis: 46, neu: 6 },
  { start: new Date(`2012 Apr 23`), app: 48, dis: 46, neu: 6 },
  { start: new Date(`2012 Apr 16`), app: 48, dis: 46, neu: 7 },
  { start: new Date(`2012 Apr 9`), app: 47, dis: 46, neu: 7 },
  { start: new Date(`2012 Apr 2`), app: 47, dis: 46, neu: 8 },
  { start: new Date(`2012 Mar 26`), app: 46, dis: 45, neu: 9 },
  { start: new Date(`2012 Mar 19`), app: 46, dis: 45, neu: 8 },
  { start: new Date(`2012 Mar 12`), app: 46, dis: 47, neu: 7 },
  { start: new Date(`2012 Mar 5`), app: 48, dis: 44, neu: 8 },
  { start: new Date(`2012 Feb 27`), app: 45, dis: 48, neu: 6 },
  { start: new Date(`2012 Feb 20`), app: 45, dis: 47, neu: 8 },
  { start: new Date(`2012 Feb 13`), app: 45, dis: 47, neu: 8 },
  { start: new Date(`2012 Feb 6`), app: 47, dis: 47, neu: 6 },
  { start: new Date(`2012 Jan 30`), app: 46, dis: 47, neu: 8 },
  { start: new Date(`2012 Jan 23`), app: 45, dis: 48, neu: 8 },
  { start: new Date(`2012 Jan 16`), app: 45, dis: 46, neu: 9 },
  { start: new Date(`2012 Jan 9`), app: 45, dis: 47, neu: 8 },
  { start: new Date(`2012 Jan 2`), app: 46, dis: 47, neu: 8 },
  { start: new Date(`2011 Dec 26`), app: 42, dis: 49, neu: 9 },
  { start: new Date(`2011 Dec 19`), app: 45, dis: 47, neu: 8 },
  { start: new Date(`2011 Dec 12`), app: 42, dis: 50, neu: 8 },
  { start: new Date(`2011 Dec 5`), app: 43, dis: 50, neu: 7 },
  { start: new Date(`2011 Nov 28`), app: 42, dis: 50, neu: 8 },
  { start: new Date(`2011 Nov 21`), app: 43, dis: 49, neu: 8 },
  { start: new Date(`2011 Nov 14`), app: 43, dis: 49, neu: 9 },
  { start: new Date(`2011 Nov 7`), app: 43, dis: 48, neu: 9 },
  { start: new Date(`2011 Oct 31`), app: 43, dis: 50, neu: 8 },
  { start: new Date(`2011 Oct 24`), app: 43, dis: 49, neu: 8 },
  { start: new Date(`2011 Oct 17`), app: 41, dis: 51, neu: 8 },
  { start: new Date(`2011 Oct 10`), app: 41, dis: 52, neu: 8 },
  { start: new Date(`2011 Oct 3`), app: 40, dis: 53, neu: 8 },
  { start: new Date(`2011 Sep 26`), app: 41, dis: 50, neu: 9 },
  { start: new Date(`2011 Sep 19`), app: 41, dis: 51, neu: 8 },
  { start: new Date(`2011 Sep 12`), app: 40, dis: 52, neu: 8 },
  { start: new Date(`2011 Sep 5`), app: 43, dis: 49, neu: 8 },
  { start: new Date(`2011 Aug 29`), app: 42, dis: 51, neu: 8 },
  { start: new Date(`2011 Aug 22`), app: 40, dis: 53, neu: 8 },
  { start: new Date(`2011 Aug 15`), app: 40, dis: 53, neu: 7 },
  { start: new Date(`2011 Aug 8`), app: 40, dis: 52, neu: 8 },
  { start: new Date(`2011 Aug 1`), app: 42, dis: 50, neu: 8 },
  { start: new Date(`2011 Jul 25`), app: 42, dis: 49, neu: 8 },
  { start: new Date(`2011 Jul 18`), app: 43, dis: 48, neu: 8 },
  { start: new Date(`2011 Jul 11`), app: 44, dis: 48, neu: 8 },
  { start: new Date(`2011 Jul 4`), app: 46, dis: 45, neu: 9 },
  { start: new Date(`2011 Jun 27`), app: 46, dis: 47, neu: 8 },
  { start: new Date(`2011 Jun 20`), app: 43, dis: 49, neu: 7 },
  { start: new Date(`2011 Jun 13`), app: 47, dis: 45, neu: 8 },
  { start: new Date(`2011 Jun 6`), app: 46, dis: 44, neu: 9 },
  { start: new Date(`2011 May 30`), app: 50, dis: 42, neu: 8 },
  { start: new Date(`2011 May 23`), app: 49, dis: 43, neu: 8 },
  { start: new Date(`2011 May 16`), app: 50, dis: 43, neu: 8 },
  { start: new Date(`2011 May 9`), app: 49, dis: 43, neu: 8 },
  { start: new Date(`2011 May 2`), app: 51, dis: 40, neu: 9 },
  { start: new Date(`2011 Apr 25`), app: 44, dis: 47, neu: 9 },
  { start: new Date(`2011 Apr 18`), app: 43, dis: 48, neu: 9 },
  { start: new Date(`2011 Apr 11`), app: 43, dis: 48, neu: 9 },
  { start: new Date(`2011 Apr 4`), app: 45, dis: 46, neu: 9 },
  { start: new Date(`2011 Mar 28`), app: 48, dis: 44, neu: 8 },
  { start: new Date(`2011 Mar 21`), app: 45, dis: 47, neu: 8 },
  { start: new Date(`2011 Mar 14`), app: 48, dis: 44, neu: 9 },
  { start: new Date(`2011 Mar 7`), app: 47, dis: 45, neu: 9 },
  { start: new Date(`2011 Feb 28`), app: 46, dis: 46, neu: 8 },
  { start: new Date(`2011 Feb 21`), app: 48, dis: 44, neu: 8 },
  { start: new Date(`2011 Feb 14`), app: 48, dis: 43, neu: 9 },
  { start: new Date(`2011 Feb 7`), app: 48, dis: 43, neu: 8 },
  { start: new Date(`2011 Jan 31`), app: 47, dis: 45, neu: 8 },
  { start: new Date(`2011 Jan 24`), app: 50, dis: 42, neu: 9 },
  { start: new Date(`2011 Jan 17`), app: 50, dis: 42, neu: 8 },
  { start: new Date(`2011 Jan 10`), app: 49, dis: 42, neu: 9 },
  { start: new Date(`2011 Jan 3`), app: 48, dis: 45, neu: 7 },
  { start: new Date(`2010 Dec 27`), app: 48, dis: 44, neu: 8 },
  { start: new Date(`2010 Dec 20`), app: 47, dis: 46, neu: 7 },
  { start: new Date(`2010 Dec 13`), app: 46, dis: 46, neu: 9 },
  { start: new Date(`2010 Dec 6`), app: 45, dis: 48, neu: 7 },
  { start: new Date(`2010 Nov 29`), app: 46, dis: 46, neu: 9 },
  { start: new Date(`2010 Nov 22`), app: 45, dis: 47, neu: 9 },
  { start: new Date(`2010 Nov 15`), app: 46, dis: 46, neu: 7 },
  { start: new Date(`2010 Nov 8`), app: 44, dis: 48, neu: 8 },
  { start: new Date(`2010 Nov 1`), app: 45, dis: 47, neu: 8 },
  { start: new Date(`2010 Oct 25`), app: 45, dis: 48, neu: 7 },
  { start: new Date(`2010 Oct 18`), app: 44, dis: 48, neu: 8 },
  { start: new Date(`2010 Oct 11`), app: 45, dis: 47, neu: 9 },
  { start: new Date(`2010 Oct 4`), app: 46, dis: 48, neu: 7 },
  { start: new Date(`2010 Sep 27`), app: 46, dis: 47, neu: 7 },
  { start: new Date(`2010 Sep 20`), app: 44, dis: 48, neu: 8 },
  { start: new Date(`2010 Sep 13`), app: 46, dis: 47, neu: 7 },
  { start: new Date(`2010 Sep 6`), app: 46, dis: 46, neu: 8 },
  { start: new Date(`2010 Aug 30`), app: 45, dis: 47, neu: 8 },
  { start: new Date(`2010 Aug 23`), app: 43, dis: 49, neu: 8 },
  { start: new Date(`2010 Aug 16`), app: 43, dis: 50, neu: 7 },
  { start: new Date(`2010 Aug 9`), app: 44, dis: 48, neu: 8 },
  { start: new Date(`2010 Aug 2`), app: 45, dis: 48, neu: 7 },
  { start: new Date(`2010 Jul 26`), app: 45, dis: 47, neu: 8 },
  { start: new Date(`2010 Jul 19`), app: 45, dis: 47, neu: 8 },
  { start: new Date(`2010 Jul 12`), app: 46, dis: 46, neu: 8 },
  { start: new Date(`2010 Jul 5`), app: 46, dis: 47, neu: 7 },
  { start: new Date(`2010 Jun 28`), app: 46, dis: 45, neu: 9 },
  { start: new Date(`2010 Jun 21`), app: 45, dis: 46, neu: 9 },
  { start: new Date(`2010 Jun 14`), app: 47, dis: 45, neu: 8 },
  { start: new Date(`2010 Jun 7`), app: 46, dis: 46, neu: 8 },
  { start: new Date(`2010 May 31`), app: 47, dis: 45, neu: 8 },
  { start: new Date(`2010 May 24`), app: 46, dis: 46, neu: 8 },
  { start: new Date(`2010 May 17`), app: 48, dis: 45, neu: 8 },
  { start: new Date(`2010 May 10`), app: 49, dis: 43, neu: 7 },
  { start: new Date(`2010 May 3`), app: 50, dis: 43, neu: 8 },
  { start: new Date(`2010 Apr 26`), app: 48, dis: 45, neu: 7 },
  { start: new Date(`2010 Apr 19`), app: 50, dis: 43, neu: 7 },
  { start: new Date(`2010 Apr 12`), app: 48, dis: 45, neu: 7 },
  { start: new Date(`2010 Apr 5`), app: 47, dis: 46, neu: 6 },
  { start: new Date(`2010 Mar 29`), app: 49, dis: 44, neu: 7 },
  { start: new Date(`2010 Mar 22`), app: 49, dis: 44, neu: 7 },
  { start: new Date(`2010 Mar 15`), app: 48, dis: 45, neu: 7 },
  { start: new Date(`2010 Mar 8`), app: 48, dis: 45, neu: 8 },
  { start: new Date(`2010 Mar 1`), app: 49, dis: 44, neu: 7 },
  { start: new Date(`2010 Feb 22`), app: 50, dis: 43, neu: 7 },
  { start: new Date(`2010 Feb 15`), app: 49, dis: 43, neu: 8 },
  { start: new Date(`2010 Feb 8`), app: 51, dis: 42, neu: 7 },
  { start: new Date(`2010 Feb 1`), app: 50, dis: 43, neu: 8 },
  { start: new Date(`2010 Jan 25`), app: 48, dis: 45, neu: 7 },
  { start: new Date(`2010 Jan 18`), app: 49, dis: 46, neu: 6 },
  { start: new Date(`2010 Jan 11`), app: 50, dis: 43, neu: 7 },
  { start: new Date(`2010 Jan 4`), app: 51, dis: 43, neu: 7 },
  { start: new Date(`2009 Dec 28`), app: 51, dis: 43, neu: 7 },
  { start: new Date(`2009 Dec 21`), app: 51, dis: 43, neu: 7 },
  { start: new Date(`2009 Dec 14`), app: 50, dis: 43, neu: 7 },
  { start: new Date(`2009 Dec 7`), app: 49, dis: 42, neu: 8 },
  { start: new Date(`2009 Nov 30`), app: 50, dis: 44, neu: 7 },
  { start: new Date(`2009 Nov 23`), app: 50, dis: 42, neu: 8 },
  { start: new Date(`2009 Nov 16`), app: 49, dis: 44, neu: 7 },
  { start: new Date(`2009 Nov 9`), app: 53, dis: 39, neu: 8 },
  { start: new Date(`2009 Nov 2`), app: 52, dis: 42, neu: 6 },
  { start: new Date(`2009 Oct 26`), app: 53, dis: 41, neu: 7 },
  { start: new Date(`2009 Oct 19`), app: 53, dis: 39, neu: 8 },
  { start: new Date(`2009 Oct 12`), app: 52, dis: 41, neu: 7 },
  { start: new Date(`2009 Oct 5`), app: 54, dis: 38, neu: 8 },
  { start: new Date(`2009 Sep 28`), app: 52, dis: 40, neu: 8 },
  { start: new Date(`2009 Sep 21`), app: 51, dis: 41, neu: 7 },
  { start: new Date(`2009 Sep 14`), app: 52, dis: 41, neu: 7 },
  { start: new Date(`2009 Sep 7`), app: 52, dis: 41, neu: 7 },
  { start: new Date(`2009 Aug 31`), app: 53, dis: 40, neu: 7 },
  { start: new Date(`2009 Aug 24`), app: 50, dis: 43, neu: 7 },
  { start: new Date(`2009 Aug 17`), app: 52, dis: 41, neu: 7 },
  { start: new Date(`2009 Aug 10`), app: 54, dis: 40, neu: 7 },
  { start: new Date(`2009 Aug 3`), app: 56, dis: 37, neu: 7 },
  { start: new Date(`2009 Jul 27`), app: 54, dis: 39, neu: 7 },
  { start: new Date(`2009 Jul 20`), app: 56, dis: 38, neu: 7 },
  { start: new Date(`2009 Jul 13`), app: 59, dis: 33, neu: 7 },
  { start: new Date(`2009 Jul 6`), app: 58, dis: 34, neu: 7 },
  { start: new Date(`2009 Jun 29`), app: 60, dis: 32, neu: 8 },
  { start: new Date(`2009 Jun 22`), app: 60, dis: 33, neu: 7 },
  { start: new Date(`2009 Jun 15`), app: 59, dis: 34, neu: 7 },
  { start: new Date(`2009 Jun 8`), app: 61, dis: 31, neu: 8 },
  { start: new Date(`2009 Jun 1`), app: 62, dis: 31, neu: 7 },
  { start: new Date(`2009 May 25`), app: 63, dis: 30, neu: 7 },
  { start: new Date(`2009 May 18`), app: 64, dis: 28, neu: 8 },
  { start: new Date(`2009 May 11`), app: 64, dis: 29, neu: 8 },
  { start: new Date(`2009 May 4`), app: 66, dis: 27, neu: 7 },
  { start: new Date(`2009 Apr 27`), app: 65, dis: 29, neu: 6 },
  { start: new Date(`2009 Apr 20`), app: 65, dis: 29, neu: 6 },
  { start: new Date(`2009 Apr 13`), app: 62, dis: 29, neu: 9 },
  { start: new Date(`2009 Apr 6`), app: 61, dis: 28, neu: 11 },
  { start: new Date(`2009 Mar 30`), app: 62, dis: 28, neu: 10 },
  { start: new Date(`2009 Mar 23`), app: 61, dis: 29, neu: 10 },
  { start: new Date(`2009 Mar 16`), app: 63, dis: 26, neu: 10 },
  { start: new Date(`2009 Mar 9`), app: 62, dis: 28, neu: 11 },
  { start: new Date(`2009 Mar 2`), app: 62, dis: 27, neu: 12 },
  { start: new Date(`2009 Feb 23`), app: 64, dis: 23, neu: 13 },
  { start: new Date(`2009 Feb 16`), app: 62, dis: 25, neu: 13 },
  { start: new Date(`2009 Feb 9`), app: 64, dis: 22, neu: 14 },
  { start: new Date(`2009 Feb 2`), app: 65, dis: 21, neu: 15 },
  { start: new Date(`2009 Jan 26`), app: 66, dis: 18, neu: 17 },
  { start: new Date(`2009 Jan 21`), app: 67, dis: 13, neu: 22 },
];
export const obamaAppData = {
  president: `Barak H. Obama`,
  party: `Democrat`,
  chart: Object.assign({}, approvalChartDefault, {
    title: { text: `Presidential Approval Poll for Barak Obama` },
  }),
};
